import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'bytesToMb' })
export class BytesToMbPipe implements PipeTransform {
  transform(value: number): number {
    const mbs = value / (8 * 1000 * 1000);
    return mbs;
  }
}
